import React, { useCallback, useContext, useMemo } from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { UserContext } from '@contexts/user-context';
import { IconSizes } from '@pulse-web-ui/icons/lib/icons.constants';
import SomethingWentWrongIcon from '@pulse-web-ui/icons/lib/lazy/rgs-tech-works';
import { observer } from 'mobx-react-lite';

import { useCommonTranslation } from '@shared/i18n';
import {
  StateBlock,
  TextLink,
  getSupportMailDataValues,
  useStores,
} from '@shared/index';

import { DescriptionContainer } from './error-default.styles';
import type { ErrorDefaultProps } from './types';

export const ErrorDefault = observer(
  ({ resetErrorBoundary }: ErrorDefaultProps) => {
    const { t } = useTranslation('COMMON');

    const tCommon = useCommonTranslation();

    const { pathname } = useLocation();
    const { getUserName } = useContext(UserContext);
    const {
      MainStore: {
        agentContractStore: { profile },
        agentUserStore: { agent },
      },
    } = useStores();
    const username = getUserName();

    const values = useMemo(
      () =>
        getSupportMailDataValues({
          t,
          username,
          profile,
          agent,
          appealPlace: window.location.href,
        }),
      [t, username, profile, agent, pathname, window.location.href]
    );

    const onSubmitHandler = useCallback(() => resetErrorBoundary(), []);

    return (
      <StateBlock
        title={tCommon('headers.somethingWentWrong')}
        description={
          <DescriptionContainer>
            <Trans
              components={{
                supportLink: <TextLink href={values.mailtoHref} />,
              }}
            >
              {tCommon('subHeaders.tryAgainOrContactSupport') +
                tCommon('mailto.body')}
            </Trans>
          </DescriptionContainer>
        }
        icon={<SomethingWentWrongIcon size={IconSizes.large} />}
        submitButtonText={tCommon('buttons.okay')}
        onSubmit={onSubmitHandler}
      />
    );
  }
);
